import { useMemo } from 'react';
import GameCard from '@/components/core/Games/GameCard/Versions/Primary';
import { UserBonusModalContentGamesProps } from './props';
import { Game } from '@/models/game';
import { ErrorCard } from '@starsoft/common/components';
import Carousel from '@/components/Home/Carousel';
import { useBonusGameMappings } from '@/api/bonus-game-mappings';
import styles from './styles.module.scss';

export default function UserBonusModalContentGames({
  isLoading,
  userBonus,
}: UserBonusModalContentGamesProps) {
  const {
    error,
    refetch,
    metadata,
    isPending,
    hasNextPage,
    fetchNextPage,
    bonusGameMappings,
    isFetchingNextPage,
  } = useBonusGameMappings({
    bonusId: userBonus?.bonus?.id as bigint,
  });

  const games: Game[] = useMemo(
    () => bonusGameMappings?.map(bonusGameMapping => bonusGameMapping?.game),
    [bonusGameMappings],
  );
  const Games: JSX.Element[] = useMemo(
    () =>
      games?.map(game => (
        <div className={styles.game} key={`game-card-${game?.id}`}>
          <GameCard game={game} />
        </div>
      )),
    [games],
  );

  const Skeletons: JSX.Element[] = useMemo(
    () =>
      Array.from({ length: 10 }).map((_, i) => (
        <div className={styles.game} key={`game-card-skeleton-${i}`}>
          <GameCard isLoading />
        </div>
      )),
    [],
  );

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  return (
    <Carousel
      paginated={{
        fetchNextPage,
        loading: isLoading,
        isFetchingNextPage,
        count: games?.length,
        hasNextPage: hasNextPage,
        totalCount: metadata?.count,
      }}
      secondaryStyles
    >
      {!isLoading && !isPending && Games}
      {(isLoading || isPending || isFetchingNextPage) && Skeletons}
    </Carousel>
  );
}
